import range from 'lodash-es/range'

import { sleep } from '../../../utils/async'

const CALENDAR_SETTINGS_FORMS_LATENCY = 400

const CALENDAR_SETTINGS_FORMS_TASK_TYPE_COUNT = 30

const CALENDAR_SETTINGS_FORMS_TASK_TYPE_NAME_DIGITS = 2

export const CALENDAR_SETTINGS_FORMS_MANY_TASK_TYPES = {
  daily_followup_limit: 10,
  show_provider_tasks: true,
  task_types: range(CALENDAR_SETTINGS_FORMS_TASK_TYPE_COUNT).map(index => ({
    calendar_relevant: index % 3 === 0,
    id: index + 100,
    name: `Task type ${String(index + 1).padStart(CALENDAR_SETTINGS_FORMS_TASK_TYPE_NAME_DIGITS, '0')}`,
    used_by_template: index % 4 === 0,
  })),
  timezone: 'Europe/Vienna',
}

export const CALENDAR_SETTINGS_FORMS_EMPTY = {
  daily_followup_limit: null,
  show_provider_tasks: false,
  task_types: [],
  timezone: null,
}

export function saveCalendarSettingsFormsDemo() {
  return sleep(CALENDAR_SETTINGS_FORMS_LATENCY)
}
